import { Skeleton } from 'antd';
import React from 'react';
import {
  ChartContainer,
  ChartWrapper,
  SelectorContainer,
  TotalCard,
  TotalsContainer,
} from '../../Charts/DailyConsumptionChart/styles';

const ChartSkeleton: React.FC = () => {
  return (
    <ChartContainer>
      {/* Skeleton para os cards de totais */}
      <TotalsContainer>
        <TotalCard>
          <Skeleton.Input
            active
            size="large"
            style={{ width: '100px', height: '32px', marginBottom: '8px' }}
          />
          <Skeleton.Input
            active
            size="small"
            style={{ width: '120px', height: '16px' }}
          />
        </TotalCard>
        <TotalCard>
          <Skeleton.Input
            active
            size="large"
            style={{ width: '100px', height: '32px', marginBottom: '8px' }}
          />
          <Skeleton.Input
            active
            size="small"
            style={{ width: '120px', height: '16px' }}
          />
        </TotalCard>
      </TotalsContainer>

      {/* Skeleton para os seletores */}
      <SelectorContainer>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Skeleton.Button active size="default" style={{ width: '80px' }} />
          <Skeleton.Button active size="default" style={{ width: '80px' }} />
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Skeleton.Input active size="default" style={{ width: '120px' }} />
          <Skeleton.Input active size="default" style={{ width: '80px' }} />
        </div>
      </SelectorContainer>

      {/* Skeleton para o gráfico */}
      <ChartWrapper>
        <div
          style={{
            width: '100%',
            height: '400px',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-around',
            padding: '20px',
            gap: '8px',
          }}
        >
          {/* Barras do skeleton */}
          {Array.from({ length: 12 }, (_, index) => (
            <div
              key={index}
              style={{
                width: '20px',
                height: `${Math.random() * 200 + 50}px`,
                backgroundColor: '#f0f0f0',
                borderRadius: '4px 4px 0 0',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${index * 0.1}s`,
              }}
            />
          ))}
        </div>
      </ChartWrapper>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.4;
            }
          }
        `}
      </style>
    </ChartContainer>
  );
};

export default ChartSkeleton;
